import Keycloak from 'keycloak-js'

const kc = new Keycloak({
    url: 'http://localhost:8080',
    realm: 'master',
    clientId: 'TEST001',
    bearerOnly: false
})

const initKeycloak =  async (authed, unauthed) => {
    await kc.init({
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        pkceMethod: 'S256',
        checkLoginIframe: false
    }).then((authenticated) => {
        if (!authenticated) {
            //not login
            unauthed()
        } else {
            authed()
        }
    }).catch((error) => {
        console.log(error)
    })
}

const getUserInfo = () => kc.tokenParsed

const dologin = () => kc.login()

export default {
    initKeycloak,
    getUserInfo,
    dologin
}